import styled, { css } from "styled-components";
import { COLORS } from "../../../assets/constants/styles";

const SIZE_PRESETS = {
  1: {
    fontSize: "2.5",
    lineHeight: "3rem",
  },
  2: {
    fontSize: "1.25",
    lineHeight: "1.5rem",
  },
  3: {
    fontSize: "1",
    lineHeight: "1.2rem",
  },
};

const baseHeadingStyles = css`
  font-weight: 700;
  margin: 0;
  margin-bottom: ${({ $marginBottom = "0" }) => $marginBottom}rem;
  color: ${(props) => props.$color || COLORS.black};
  display: flex;
  align-content: center;
  flex-wrap: wrap;

  ${({ size }) => {
    const preset = SIZE_PRESETS[size] || SIZE_PRESETS[1];
    return css`
      font-size: ${preset.fontSize}rem;
      line-height: ${preset.lineHeight};
    `;
  }}
`;

const H1 = styled.h1`
  ${baseHeadingStyles}
`;
const H2 = styled.h2`
  ${baseHeadingStyles}
`;
const H3 = styled.h3`
  ${baseHeadingStyles}
`;

const HEADING_COMPONENTS = {
  1: H1,
  2: H2,
  3: H3,
};

export const Heading = ({ text, marginBottom, size, color, ...props }) => {
  const HeadingComponent = HEADING_COMPONENTS[size] || H1;

  return (
    <HeadingComponent
      $marginBottom={marginBottom}
      size={size}
      {...props}
      $color={color}
    >
      {text}
    </HeadingComponent>
  );
};
